import { render } from "./imageElement.vue?vue&type=template&id=5211aaf6&ts=true"
import script from "./imageElement.vue?vue&type=script&lang=ts"
export * from "./imageElement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__